/**
 * 证书挂靠
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/10/27     1.0     First version
 *
 * Copyright 2023, all rights reserved. Essa.cn
 * */
import React,{PureComponent} from "react";
import {Alert, Button, Input, message, Popconfirm, Spin} from 'antd';
import { isEmptyObject,isEmpty,postHttpAction,trim } from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import _ from "lodash";
import CertificateDetail from './detail/certificateDetail';
import CertificateRule from './rule/certificateRule';
import "./attachmentRule.less";
const { TextArea } = Input;
export default class CertificateAttachmentRule extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
        };
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    loadingCate(flag) {
        this.setState({
            loadingCate: flag,
        });
    }
    IconMate = (size=24) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="#1EB071"/>
            </svg>
        );
    }
    IconExclude = (size=24) => {
        return (<svg xmlns="http://www.w3.org/2000/svg"width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M15.935 2.50098L21.5 8.06595V15.936L15.935 21.501H8.06497L2.5 15.936V8.06595L8.06497 2.50098H15.935ZM7.99926 11.0002V13.0002H15.9993V11.0002H7.99926Z" fill="#E4393C"/>
        </svg>);
    }
    /**
    * 添加 规则
    * @param ruleType 类型 1 匹配规则， 2 排除规则
    *  */
    pushRuleList(ruleType=1,id){
        if(ruleType==2){
            const { excludeList =[]} = this.state;
            let newAttrs = [...excludeList]
            newAttrs.push({
                id: id,
                ruleType: 2 ,// 规则类型
            })
            this.setState({
                excludeList: newAttrs
            })
        }else {
            const { mateList =[]} = this.state;
            let newAttrs = [...mateList]
            newAttrs.push({
                id: id,
                ruleType: 1 , // 规则类型
            })
            this.setState({
                mateList: newAttrs
            })
        }

    }

    /**
     * 复制规则
     * @param ruleType   类型 1 匹配规则， 2 排除规则
     * @param inxRule   序号
     * @param yPageState   原规则内已产生的页面数据
     * */
    copyRule(ruleType=1,inxRule,yPageState){
        if(ruleType==2){
            const {excludeList = []} = this.state;
            let newAttrs = [...excludeList];
            let current = { ...excludeList[inxRule],
                pageState:{...yPageState}
            };
            current["id"] = "copy_"+current.id;
            const newObj = _.cloneDeep(current);
            newAttrs.push(newObj)
            this.setState({
                excludeList: newAttrs
            })
            setTimeout(()=>{
                message.success(Lang({id:"FuZhiPaiChuGuiZeChengGong",default:`复制 排除规则${newAttrs.length} 成功！`,params:[newAttrs.length]}));
            },600)
        }else {
            const {mateList = []} = this.state;
            let current = {
                ...mateList[inxRule],
                pageState:{...yPageState},
            };
            current["id"] = "copy_"+current.id;
            const newObj = _.cloneDeep(current);
            let newAttrs = [...mateList]
            newAttrs.push(newObj)
            this.setState({
                mateList: newAttrs
            })
            setTimeout(()=>{
                // message.success(`复制 匹配规则${newAttrs.length} 成功！`);
                message.success(Lang({id:"FuZhiPiPeiGuiZeChengGong",default:`复制 匹配规则${newAttrs.length} 成功！`,params:[newAttrs.length]}));
            },600)
        }
    }

    /**
     * 删除规则
     * @param ruleType   类型 1 匹配规则， 2 排除规则
     * @param inxRule   序号
     * */
    deleteRule(ruleType=1,inxRule){
        if(ruleType==2){
            const {excludeList = []} = this.state;
            let newAttrs = [...excludeList]
            newAttrs.splice(inxRule, 1);
            this.setState({
                excludeList: newAttrs
            })
        }else {
            const {mateList = []} = this.state;
            let newAttrs = [...mateList]
            newAttrs.splice(inxRule, 1);
            this.setState({
                mateList: newAttrs
            })
        }
    }
    /**
     * 修改规则 属性值
     * @param ruleType   类型 1 匹配规则， 2 排除规则
     * @param inxRule   序号
     * @param sField  默认修改属性attrValues，如果传入 selectedCategorySure 即修改所选类目
     * */
    changeAttrValues(ruleType=1,inxRule,values,sField="attrValues"){
        if(ruleType==2){
            const {excludeList = []} = this.state;
            let newAttrs = [...excludeList];
            newAttrs[inxRule] = {...newAttrs[inxRule]};
            newAttrs[inxRule][sField] = values;
            if(sField=="selectedCategorySure"){ // 操作过 类目 就不再显示错误信息
                newAttrs[inxRule]["hadCategoryDelete"] = false;
            }
            this.setState({
                excludeList: newAttrs
            })
        }else {
            const {mateList = []} = this.state;
            let newAttrs = [...mateList];
            newAttrs[inxRule] = {...mateList[inxRule]};
            newAttrs[inxRule][sField] = values;
            if(sField=="selectedCategorySure"){ // 操作过 类目 就不再显示错误信息
                newAttrs[inxRule]["hadCategoryDelete"] = false;
            }
            this.setState({
                mateList: newAttrs
            })
        }
    }
    /*
    * 修改海关编码
    * */
    handleTextAreaChange(field="",str=""){
        const {values = {}} = this.state;
        let newValues = {...values};
        let newArr = []
        if(field=="customsCodeList"){
            const arr =  str.trim().split('\n');
            const reg = /^[A-Za-z0-9]{10}$/
            let hasErr = false;
            arr.forEach(item=>{
                if(item&&reg.test(item)){
                    newArr.push(item)
                }else if(item){ // 有非空行 错误  提示
                    hasErr = true
                }else return;
            })
            newValues[field] = newArr;
            newValues["hasErrCustomsCode"] = hasErr;
        }else if(field=="skuList") { //商品编号
            const arr =  str.trim().split('\n');
            arr.forEach(item=>{
                if(isEmpty(item)){
                    return
                }else {
                    newArr.push(trim(item))
                }
            })
            newValues[field] = newArr;
        }else {
            newValues[field] = str;
        }
        this.setState({
            values:newValues
        })
    }
    /*
     * 保存数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8037
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8072
     * 规则：类目必选，属性可无（属性及属性值均存在才保存）
     *  ruleAttrList =  [
        *   attributeId	属性Id	number	isNonAttr = 1 才有
        *   isNonAttr	是否非属性 0:非属性(材质) 1:属性	number
        *   joinType	0:或 1:并	number
        *   name	名称	string
        *   nonAttrCategoryCode	非属性code(字典categort_code)	string	isNonAttr = 0 才有
        *   optionList	属性选项集合	array<object>
     *  ]
     *  //  不需要        isMulti	是否多值 0:不是 1:是	number
     * */
    save(){
        let { values={},excludeList=[],mateList=[],saleGoodsCertificateId } = this.state;
        if(values.hasErrCustomsCode){ // 海关编码 非必填 ，如果有填 的话就是只接受十位数的大小写英文+数字
            this.setState({
                submitStatus:1
            })
           return false
        }else {
            values.flagHadCategoryDelete = false;
            let ruleList = [],hadCategoryDelete = false;
            this.handleDataSave(mateList,ruleList,values);
            this.handleDataSave(excludeList,ruleList,values);
            if(values.flagHadCategoryDelete){
                message.warning(Lang({id:"GuiZeLeiMuYuZhengShuLeiMuBuPiPei",default:"规则类目与证书类目不匹配，请检查后再保存"}));
            }
            const iLen = mateList.length + excludeList.length;
            if(ruleList.length==iLen){
                const postData = {
                    saleGoodsCertificateId:saleGoodsCertificateId,
                    customsCodeList:values.customsCodeList||[],
                    excludeSkuNoList: values.skuList||[],
                    ruleList:ruleList,
                }
                this.loading(true);
                postHttpAction('/service/mg/certificate/add-update-rule', postData, (resData) => {
                    this.loading(false);
                    const { success,valid,model={} } = resData;
                    if(success&&valid){
                        message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}),3);
                        this.reloadRule();
                    }else if(resData.message) message.success(resData.message);
                })
            }else { // 如果提交规则与 组装前规则条数不匹配即存在 无选择类目规则
                this.setState({
                    submitStatus:1
                })
            }
        }
    }
    /*
    * 组装 需要保存数据
    * 类目为必填
    * */
    handleDataSave(list=[],ruleList=[],values){
        list.forEach((item={})=>{
            if(isEmptyObject(item.selectedCategorySure)){
                return false
            }else {
                let categoryList = [],ruleAttrList=[];
                for(let key in item.selectedCategorySure){
                    const cate = item.selectedCategorySure[key];
                    if(cate.hadValid){ // 增 有校验过的 规则类目 才提交
                        categoryList.push({
                            level: cate.level,
                            prdCategoryId: cate.id
                        })
                    }
                }
                if(categoryList.length==0){// 规则类目 已失效但无操作可能出现 无有效类目情况 拦截提交
                    item.hadCategoryDelete = true;
                    values.flagHadCategoryDelete = true
                    return false
                }
                if(item.attrValues&&item.attrValues.length>0){
                    item.attrValues.forEach((att={})=>{ // 属性列表
                        const source = att.source||{}; // 属性的 完整来源对象
                        if(att.value&&att.value.length>0&&source.sourceOptionList&&source.sourceOptionList.length>0){
                            let optionList = [];//属性 值 选项集合
                            att.value.forEach(op=>{
                                // name	名称， nonAttrCode	非属性code(字典code)， optionId	属性选项Id
                                const opObj = source.sourceOptionList.find(item=>item.nonAttrCode==op||item.optionId==op);
                                if(opObj){ // 切换了类目数据，如果操作人不处理新的属性条件 保存时匹配到属性不属于当前类目的数据不保存
                                    optionList.push({
                                        name:opObj.name,
                                        nonAttrCode:opObj.nonAttrCode,
                                        optionId:opObj.optionId,
                                    })
                                }
                            })
                            if(optionList.length>0){ // 属性 及值 均有才放入提交
                                ruleAttrList.push({
                                    attributeId:source.attributeId,
                                    isNonAttr:source.isNonAttr,
                                    joinType: att.optionType=="and"?1:0,// 0:或 1:并
                                    name:source.name,
                                    nonAttrCategoryCode:source.nonAttrCategoryCode,
                                    type:source.type,
                                    optionList: optionList
                                })
                            }
                        }

                    })
                }
                ruleList.push({
                    type: item.ruleType == 2? 0: 1, // 前端的 ruleType 类型 1 匹配规则， 2 排除规则 == 》 后端规则类型 0:排除 1:匹配
                    categoryList:categoryList,
                    ruleAttrList:ruleAttrList
                })
            }
        })
        return ruleList;
    }
    /*
   * 商品证书规则详情
   * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8038
   * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8071
   * */
    getDetail(saleGoodsCertificateId,callBack){
        this.loading(true);
        postHttpAction('/service/mg/certificate/query-rule', {
            saleGoodsCertificateId:saleGoodsCertificateId
        }, (resData) => {
            const { success,valid,model={} } = resData;
            if(success&&valid){
                let sCustomsCode = "",sSkus = "";
                const customsCodeList = model.customsCodeList||[], excludeSkuNoList = model.excludeSkuNoList || [] ;
                customsCodeList.forEach(str=>sCustomsCode += str + "\n");
                excludeSkuNoList.forEach(str=>sSkus += str + "\n");
                //  前端的 ruleType 类型 1 匹配规则，  2 排除规则
                const mateList = this.handleRule(model.ruleList,1);
                const excludeList = this.handleRule(model.excludeRuleList,2);
                this.setState({
                    values:{
                        sCustomsCode:sCustomsCode,
                        sSkus:sSkus,
                        customsCodeList:customsCodeList,
                        skuList:excludeSkuNoList,
                    },
                    mateList:mateList,
                    excludeList:excludeList
                },()=>{
                    if(typeof callBack=='function'){
                        callBack();
                    }
                })

            }
            this.loading(false);
        })
    }
    /*
    * 处理规则回显
    * */
    handleRule(ruleList=[],ruleType=1){
        const { categoryAllList } = this.state;
        let mateList=[];
        ruleList.forEach((item={})=>{
            let selectedCategorySure = {},attrValues=[];
            (item.categoryList||[]).forEach((cate={},inx)=>{
                let item =  {
                    id:cate.prdCategoryId, //后端类目Id
                    level:cate.level,
                    sort:inx,
                    prdCategoryName:cate.prdCategoryName,//后端格式化后的 显示字符串
                }
                const has = categoryAllList.find(cateValid=>cate.prdCategoryId==cateValid.id);//对比可选择的类目
                if(has&&!isEmptyObject(has)){ // 由于要求 已删除的类目需要显示 ，但保存时要过滤， 增 hadValid为true 才提交
                    item.hadValid = true
                }
                selectedCategorySure[cate.prdCategoryId] = item;
            });
            (item.ruleAttrList||[]).forEach((att={},inx)=>{
                let opList = [];
                // 是否非属性 0:非属性(材质) 1:属性 如果是属性拿 属性 optionId ，其他 拿 nonAttrCode
                att.optionList.forEach(op=>opList.push(att.isNonAttr==1?op.optionId:op.nonAttrCode));
                attrValues.push({
                    field:att.isNonAttr==1?att.attributeId:att.nonAttrCategoryCode, //属性键
                    id:att.id,
                    optionType: att.joinType==1?"and":"or",//规则链接类型 0:或 1:并
                    value:opList,// 属性值 列表
                    // source:{// 查找获取
                    // }
                })
            });
            mateList.push({
                id:item.id,
                ruleType: ruleType, //   前端的 ruleType 类型 1 匹配规则，  2 排除规则
                selectedCategorySure:selectedCategorySure,
                attrValues: attrValues
            });
        });
        return mateList;
    }
    /** 获取类目树
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8036
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8067
     * */
    getCateList(saleGoodsCertificateId,callback) {
        let postData = {};
        if(!isEmpty(saleGoodsCertificateId)){
            postData["saleGoodsCertificateId"] = saleGoodsCertificateId;
        }
        this.loadingCate(true);
        postHttpAction('/service/mg/certificate/query-category-tree',postData, (resData) => {
            this.loadingCate(false);
            const { success, valid, models=[]} = resData;
            if (success &&valid) {
                const categoryList = this.pushCategoryItem(models)||[];
                this.setState({
                    categoryTree:models,
                    categoryAllList:categoryList ,
                },()=>callback());
            }else if(resData.message){
                message.warning(resData.message)
            }
        });
    }
    // 把所有类目都集中到一维数组
    pushCategoryItem(list = []) {
        let arr = [];
        list.forEach((item) => {
            arr.push(item)
            if (item.subCategories) {
                arr = [...arr, ...item.subCategories, ...this.pushCategoryItem(item.subCategories)];
            }
        });
        return arr;
    }
    /*
    * 进入查询数据
    * */
    init(){
        if(window.location.pathname){
            const id = window.location.search.substring(1);
            if(!isEmpty(id)){
                this.setState({
                    saleGoodsCertificateId:id
                })
                this.getCateList(id,()=>this.getDetail(id));
            }
        }
    }
    /*
    * 重新载入规则数据
    * PS:此处无必要重查证书详情内容
    * */
    reloadRule(){
        const { saleGoodsCertificateId,  } = this.state;
        this.getDetail(saleGoodsCertificateId,()=>{
            // 拿到新的规则数据后，重载规则组件
            this.setState({
                reloadIng: true,
            },()=>{
                this.timer = setTimeout(()=>{
                    this.setState({
                        reloadIng: false
                    })
                },200);
            })
        })
    }
    componentWillMount() {
      this.init()
    }
    componentDidMount(){
    }
    componentWillUnmount(){
        this.setState = ()=>false;
        clearTimeout(this.timer);
    }
    render() {
        const { saleGoodsCertificateId, loading,loadingCate=false,submitStatus="",mateList = [],excludeList=[],values={},reloadIng=false, categoryTree=[], categoryAllList=[] } = this.state;
        const currPageName = Lang({id: "ZhengShuGuaKaoGuiZe",default: "证书挂靠规则"});
        return (<PageCommon>
                <CommonBreadcrumb list={[
                    { name: Lang({id: 'ZhengShuGuanLi', default: '证书管理'}),link:'/goods/certificate-mgr'},
                    { name:currPageName}
                    ]}></CommonBreadcrumb>
            <Spin spinning={loading||loadingCate}>
                <div className={"pageCertificateAttachmentRuleWrap black89 font_14"}>
                    <Alert message={Lang({id: 'GuaKaoZunXunXianPiPei',
                        default: "挂靠遵循先匹配，再排除的顺序。商品一旦被排除规则命中，则标识为无证书。规则类目与证书类目不一致时，保存时将被忽略掉。"})}
                           type="info" showIcon />
                    {/* 点击弹出证书 详情*/}
                    <CertificateDetail id={saleGoodsCertificateId} type={"show"} />
                    {/* 匹配 有关内容 */}
                    <div className={"title mt_12 flex-item-ver-center"}>
                        {this.IconMate()}<span className={"ml_2"}>{Lang({id: 'PiPeiGuiZe', default: '匹配规则'})}</span>
                        <div className={"btnAdd ml_8"} onClick={()=>this.pushRuleList(1,"mate_"+mateList.length+1)}>
                            {Lang({id: 'TianJiaGuiZe', default: '添加规则'})}
                        </div>
                    </div>
                    <div className={"mt_4 font_12 black45"}>{Lang({id: 'DuoGeGuiZeShiYongHuoDeGuanXi', default: '多个规则使用或的关系，命中任意一个规则都属于匹配到'})}</div>
                    {!reloadIng&&mateList.map((mate={},mateInx)=><CertificateRule key={"mate_"+mateInx} inxRule={mateInx}
                                                                                  saleGoodsCertificateId={saleGoodsCertificateId}
                                                                                  categoryTree={categoryTree}
                                                                                  attrValues={mate.attrValues||[]} // 属性值
                                                                                  selectedCategorySure={mate.selectedCategorySure||{}}
                                                                                  hadCategoryDelete={mate.hadCategoryDelete}
                                                                      submitStatus={submitStatus}
                                                                      pageState={mate.pageState}
                                                                      changeAttrValues={(ruleType,inxRule,attrValues)=>this.changeAttrValues(ruleType,inxRule,attrValues)}
                                                                      selectedPageCates={(ruleType,inxRule,selectedCategorySure)=>this.changeAttrValues(ruleType,inxRule,selectedCategorySure,"selectedCategorySure")}
                                                                      copyRule={(ruleType,inxRule,yPageState={})=>this.copyRule(ruleType,inxRule,yPageState)}
                                                                      deleteRule={(ruleType,inxRule)=>this.deleteRule(ruleType,inxRule)} />)}
                    <div className={"mt_12 borderBox"}>
                        <div className={"mb_12"}>
                            <span className={"mr_8 black89 fw_700"}>{Lang({id:"PiPeiDeShangPinShiYongYiXiaHaiGuanBianMa",default:"匹配的商品使用以下海关编码"})}</span>
                            <span className={"font_12 black45"}>{Lang({id:"YiXingYiGeHaiGuanBianMa",default:"一行一个，海关编码为10位数的大小写英文或数字"})}</span>
                        </div>
                        <TextArea onBlur={(e)=>this.handleTextAreaChange("customsCodeList",e.target.value)}
                                  onChange={(e)=>this.handleTextAreaChange("sCustomsCode",e.target.value)}
                                  placeholder={Lang({id:"QingShuRuHaiGuanBianMa",default:"请输入海关编码"})}
                                  value={values.sCustomsCode}
                                  autoSize={{ minRows: 2, maxRows: 6 }} />
                        {values.hasErrCustomsCode&&<div className={"color-red2 mt_4"}>{Lang({id:"QingShuRuZhengQueDeHaiGuanBianMa",default:"请输入正确的海关编码"})}</div>}
                    </div>
                    {/* 排除 有关内容 */}
                    <div className={"title mt_12 flex-item-ver-center"}>
                        {this.IconExclude()}<span className={"ml_2"}>
                        {Lang({id: 'PaiChuGuiZe', default: '排除规则'})}
                        </span>
                        <div className={"btnAdd ml_8"} onClick={()=>this.pushRuleList(2,"excl_"+excludeList.length+1)}>
                            {Lang({id: 'TianJiaGuiZe', default: '添加规则'})}
                        </div>
                    </div>
                    <div className={"mt_4 font_12 black45"}>{Lang({id: 'DuoGeGuiZeShiYongHuoDeGuanXi', default: '多个规则使用或的关系，命中任意一个规则都属于匹配到'})}</div>
                    {!reloadIng&&excludeList.map((mate={},excludeInx)=><CertificateRule key={"excl_"+excludeInx} inxRule={excludeInx} ruleType={2}
                                                                                        saleGoodsCertificateId={saleGoodsCertificateId}
                                                                                        categoryTree={categoryTree}
                                                                                        attrValues={mate.attrValues||[]} // 属性值
                                                                            selectedCategorySure={mate.selectedCategorySure||{}}
                                                                                        hadCategoryDelete={mate.hadCategoryDelete}
                                                                            submitStatus={submitStatus}
                                                                            pageState={mate.pageState}
                                                                            changeAttrValues={(ruleType,inxRule,values)=>this.changeAttrValues(ruleType,inxRule,values)}
                                                                                        selectedPageCates={(ruleType,inxRule,selectedCategorySure)=>this.changeAttrValues(ruleType,inxRule,selectedCategorySure,"selectedCategorySure")}
                                                                            copyRule={(ruleType,inxRule,yPageState={})=>this.copyRule(ruleType,inxRule,yPageState)}
                                                                            deleteRule={(ruleType,inxRule)=>this.deleteRule(ruleType,inxRule)} />)}
                    <div className={"mt_12 borderBox"}>
                        <div className={"mb_12"}>
                            <span className={"mr_8 black89 fw_700"}>{Lang({id:"PaiChuDiaoZhiDingShangPinBianHao",default:"排除掉指定商品编号"})}</span>
                            <span className={"font_12 black45"}>{Lang({id:"YiXingYiGeBianHao",default:"一行一个编号"})}</span>
                        </div>
                        <TextArea onBlur={(e)=>this.handleTextAreaChange("skuList",e.target.value)}
                                  placeholder={Lang({id:"QingShuRuShangPinBianHao",default:"请输入商品编号"})}
                                  onChange={(e)=>this.handleTextAreaChange("sSkus",e.target.value)}
                                  value={values.sSkus}
                                  autoSize={{ minRows: 2, maxRows: 6 }} />
                    </div>
                    <Popconfirm title={Lang({id:"ShiFouQueDingBaoCun",default:"是否确定保存"})}
                                okText={Lang({id:"QueDing",default:"确定"})}
                                cancelText={Lang({id:"QuXiao",default:"取消"})}
                                onConfirm={()=>this.save()}>
                        <Button type="primary"  className={"mt_12"}>
                            {Lang({id:"BaoCun",default:"保存"})}
                        </Button>
                    </Popconfirm>
                </div>
            </Spin>
        </PageCommon>
        );
    }
}
